import React from 'react'
import {
  Onesignal,
  TheContent,
  TheSidebar,
  TheFooter,
  TheHeader,
} from './index'

import { OnesignalModel } from '../models'

import { AuthConsumer, } from '../contexts/authContext'
import { NotificationsConsumer, } from '../contexts/notificationsContext'

import { Notifications, } from '../components/notify'
import { connect } from 'react-redux'

const onesignal_model = new OnesignalModel()

const Login = React.lazy(() => import('../views/pages/login/Login'))

const TheLayout = (props) => {
  const [state, setState] = React.useState({ total_time: 5000, })

  const _addPlayerID = async (data) => {
    if (data.player_id !== null && data.player_id !== '') {
      const datas = {
        user_code: data.user_code,
        player_id: data.player_id,
      }
      const res = await onesignal_model.insertOnesignalPlayer(datas)
      if (res.require) {
        props.setPlayerID(datas)
      }
    }
  }

  const _onIdleTime = () => {
    // endCountTime() 
  }
  var startCountTime;

  const endCountTime = () => {
    window.clearTimeout(startCountTime)
    startCountTime = setTimeout(() => {
      try {
        console.log('idle time');
        localStorage.clear()
        window.location.reload()
      } catch (e) {
        console.log('_handleLogout ', e)
      }
    }, 300000)
  }

  return (
    <AuthConsumer>
      {({ authenticated, user, permissions, company_info }) => (
        authenticated ? (
          <Notifications _USER={user}>
            <NotificationsConsumer>
              {(notify) => (
                <div
                  tabIndex={0}
                  className="c-app c-default-layout"
                  onKeyDownCapture={_onIdleTime}
                  onMouseMove={_onIdleTime}
                >
                  <TheSidebar NOTIFY={notify} PERMISSIONS={permissions} />
                  <div className="c-wrapper">
                    <TheHeader _USER={user} NOTIFY={notify} />
                    <div className="c-body">
                      <TheContent NOTIFY={notify} PERMISSIONS={permissions} USER={user} COMPANY_INFO={company_info} />
                      <Onesignal user={user.user_code} createPlayer={(e) => _addPlayerID(e)} />
                    </div>
                    <TheFooter />
                  </div>
                </div>
              )}
            </NotificationsConsumer>
          </Notifications>
        ) : <Login />
      )}
    </AuthConsumer>
  )
}

const mapStateToProps = state => ({
  player: state.player
})

const mapDispatchtoProps = (dispatch) => ({
  setPlayerID: (val) => dispatch({ type: 'set', player: val }),
})


export default connect(mapStateToProps, mapDispatchtoProps)(TheLayout)